import {
  Grid,
} from '@material-ui/core';
import { useStyles } from '@webapps/styles';

import StudentCard from './StudentCard';

const StudentsTrack = ({students, setSelectedStudent}) => {
  const {
    classes,
    css,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <Grid className={classes.studentTrack} container>
      {students?.map(
        (item) => (
          <Grid
            key={item?.id}
            item
            xs={12}
            md={6}
            xl={4}
            style={{ padding: spacing(0, 2.5, 2.5, 0) }}
          >
            <StudentCard student={item} setSelectedStudent={setSelectedStudent}/>
          </Grid>
        )
      )}
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  studentTrack: {
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    padding: spacing(2.5, 0, 0, 2.5),
    minHeight: "calc(100vh - 218px)",
    '@media (max-width:768px)': {
      margin: spacing(0),
    },
    '@media (max-width:1023px)': {
      minHeight: "calc(100vh - 396px)",
      flexFlow: 'column',
    },
  },
});

export default StudentsTrack;
